import "../chunk-BUSYA2B4.js";
import { eventFrameworkMetadata } from "@clerk/shared/telemetry";
import { useClerk } from "../client-boundary/hooks";
import { usePagesRouter } from "../client-boundary/hooks/usePagesRouter";
const RouterTelemetry = () => {
  var _a;
  const clerk = useClerk();
  const { pagesRouter } = usePagesRouter();
  (_a = clerk.telemetry) == null ? void 0 : _a.record(
    eventFrameworkMetadata({
      router: pagesRouter ? "pages" : "app"
    })
  );
  return null;
};
export {
  RouterTelemetry
};
//# sourceMappingURL=router-telemetry.js.map